<template>
  <div class="process-list">
    <home-nav-bar title="加工">
      <div slot="right" class="nav-bar-right">
        <div class="title" @click="createProcess">
          +添加工艺
        </div>
      </div>
    </home-nav-bar>
    <wh-mobile-list ref="listTable" class="main" :extra-params="extraParams" data-src="/api/getProcessing">
      <template v-slot="{list}">
        <van-cell v-for="i in list" :key="i.id" class="list-item">
          <div class="title wh-flex-between">
            <span>{{ i.craftName }}</span>
            <div class="operate">
              <span @click="editProcess(i)">编辑</span>
              <span @click="delProcess(i)">删除</span>
            </div>
          </div>
          <van-steps direction="vertical" :active="i.processingProcessInfo.length?i.processingProcessInfo.length:0" active-color="#20CAA0">
            <van-step v-for="(item,index) in i.processingProcessInfo" :key="item.id">
              <template v-slot:inactive-icon>
                <div class="inactive">
                  {{ index+1 }}
                </div>
              </template>
              <div class="step-item wh-flex-start">
                <van-image class="img" width="40" fit="cover" :src="item.photo|firstImgThumb">
                  <template v-slot:error>
                    <div class="error-img">
                      暂无图片
                    </div>
                  </template>
                </van-image>
                <div class="name">
                  <span>{{ item.processName }}</span>
                  <span>操作人：{{ item.staffName }}</span>
                </div>
              </div>
            </van-step>
          </van-steps>
        </van-cell>
      </template>
    </wh-mobile-list>
    <process-popup
      :visible.sync="popup.process.visible"
      :form-type="popup.process.formType"
      :init-form-data="popup.process.initFormData"
      @submitFormSuccess="submitFormSuccessFn"
    />
  </div>
</template>
<script>
import { firstImgThumb } from '@/filter'
import api from '@/api'
import { deepClone } from '@/utils/tool'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import ProcessPopup from '@/views/Process/components/ProcessPopup'
export default {
  components: { HomeNavBar, WhMobileList, ProcessPopup },
  filters: {
    firstImgThumb
  },
  data() {
    return {
      extraParams: {

      },
      popup: {
        process: {
          visible: false,
          formType: 'create',
          initFormData: {}
        }
      }
    }
  },
  methods: {
    deepClone,
    createProcess() {
      this.popup.process.visible = true
      this.popup.process.formType = 'create'
    },
    delProcess(i) {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        api.deleteProcessing({ id: i.id }).then(() => {
          this.$refs.listTable.onRefresh()
          this.$toast('删除成功')
        })
      }).catch(() => {})
    },
    editProcess(i) {
      this.popup.process.visible = true
      this.popup.process.formType = 'edit'
      this.popup.process.initFormData = this.deepClone(i)
    },
    submitFormSuccessFn(flag) {
      if (flag) {
        this.$refs.listTable.onRefresh()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.error-img{
  width:40px;
  height:40px;
  text-align: center;
  background-color: #eee;
  // color: #fff;
}
.inactive{
  background-color: #20CAA0;
  color: #fff;
  margin-top: 60px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
}
/deep/ .van-step__circle{
  margin-top: 30px;
  width: 20px;
  height: 20px;
}
/deep/ .van-step--vertical .van-step__line{
  width:4px;
  left: -17px;
  top: 41px;
}
/deep/ .van-step:last-child .van-step__line{
  width: 0;
}
.process-list{
  height: 100%;
  display: flex;
  flex-direction: column;
  .nav-bar-right {
    .title{
      color: #20CAA0;
    }
  }
 .main{
   margin-top: 6px;
    .list-item{
      margin-bottom: 6px;
      .title{
        color: #323332;
        font-size: 14px;
        font-weight: bold;
          .operate{
            font-size: 12px;
            font-weight: normal;
            >span:first-child {
              margin-right: 16px;
            }
            >span:last-child{
              color: #BBBBBB;
            }
          }
        }
      .step-item{
        background-color: #F8F8F8;
        height: 64px;
        padding-left: 30px;
        .img{
          margin-top: 5px;
        }
        .name{
        display: flex;
        margin-left: 15px;
        flex-direction: column;
        height: 40px;
        justify-content: space-between;
        span:nth-child(1){
          font-size: 14px;
          font-weight: bold;
          color: #323332;
        }
        span:nth-child(2){
          color: #BBBBBB;
          font-size: 12px;
        }
      }
      }

    }
  }
}
</style>
